import {
    ID,
    Resource,
    TAG,
    ValidationMaxLength,
    ValidationRequired,
} from 'simpli-web-sdk'
import StatusNotificacaoAuditoriaSchema from '@/schema/StatusNotificacaoAuditoria.schema'

export default class StatusNotificacaoAuditoria extends Resource {
    get $schema() {
        return StatusNotificacaoAuditoriaSchema(this)
    }

    get $id() {
        return this.idStatusNotificacaoAuditoriaPk
    }

    set $id(val: ID) {
        this.idStatusNotificacaoAuditoriaPk = val
    }

    get $tag() {
        return this.nome
    }

    set $tag(val: TAG) {
        this.nome = val
    }

    readonly $name: string = 'StatusNotificacaoAuditoria'

    readonly $endpoint: string = '/user/status-notificacao-auditoria'

    idStatusNotificacaoAuditoriaPk: ID = 0

    @ValidationRequired()
    @ValidationMaxLength(45)
    nome: string = ''
}
